import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import classNames from "classnames";
import {LinearProgress,Box, Fab, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, 
  Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Support from '../../components/support/Support';
import SettingsApplicationIcon from '@mui/icons-material/SettingsApplications';
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import CardIcon from "../../components/Card/CardIcon.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Skeleton from "@mui/material/Skeleton"
import GridContainer from "../../components/Grid/GridContainer.jsx";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { mongoUrl } from '../../components/shared/mongoUrl';
import { baseUrl } from '../../components/shared/baseUrl';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";


const styles = (theme) =>({
   cardTitle: {
        color: 'blue',
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
          color: grayColor[1],
          fontWeight: "400",
          lineHeight: "1"
        }
      },
     cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
      },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  fontPapyrus:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  fontMonaco:{
    fontFamily:"'Monaco','monospace'"
  },
  fontCursive: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  fontBrush: {
    fontFamily:"'Brush Script MT', 'Cursive'"
  },
  fontGaramond: {
    fontFamily:"'Garamond', 'Serif'"
  },
  fontCourier:{
    fontFamily:"'Courier New', 'monospace'"
  },
  fontLucida:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  deco:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  abs:{
    fontFamily:"'Monaco','monospace'"
  },
  algo: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  pat:{
    fontFamily:"'Courier New', 'monospace'"
  },
  ana:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontFamily:"'Lucida Handwriting', 'Brush Script MT'"
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontFamily:"'Lucida Console', 'monospace'"
  },
  modal: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
  },
  modal1:{
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  modal2:{
    position: 'relative',
    maxWidth: '500px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  }
});

var numberList = [
  { label: '', value: ''},{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 54}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
];

var numberNewList = [
  { label: '', value: ''},{ label: 'n', value: 'n' },{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
];

var bracketList = [
  { label: '(', value: '(' },
  { label: ')', value: ')'}
];

var pairList = [
  { label: 'Pairwise sum=', value: 'Pairwise sum=' },
  { label: 'Pair count=', value: 'Pair count='}
];
var nVarList = [
  {label: 'n', value: 'n'},
  {label: '', value: ''}
]

var answerList = [
  {label: 'Strongly disagree', value: 'Strongly disagree'},
  {label: 'Disagree', value: 'Disagree'},
  {label: 'Neutral', value: 'Neutral'}, 
  {label: 'Agree', value: 'Agree'},
  {label: 'Strongly agree', value: 'Strongly agree'}
]

var compareList = [
  { label: '=', value: '=' },
  { label: '==', value: '==' },
  { label: '!=', value: '!=' },
  { label: '>', value: '>' },
  { label: '>=', value: '>=' },
  { label: '<', value: '<' },
  { label: '<=', value: '<=' }
]

var operatorList = [
  { label: '+', value: '+' },
  { label: '-', value: '-'},
  { label: '*', value: '*'},
  { label: '/', value: '/'},
  { label: '', value: ''}
];

var termList = [
  { label: '... upto 60 terms', value: '... upto 60 terms' },
  { label: '... upto 30 terms', value: '... upto 30 terms'},
  { label: '', value: ''}
];

var alternateList = [
  { label: 'Individual addition', value: 'Individual addition' },
  { label: 'Pairwise addition', value: 'Pairwise addition'}
];

var task = ['Read each statement related to system usability questionnaire and provide answers accordingly', 'Read each question and provide multiple choice answers',
 'Read each statement and provide answers accorfingly']


function getSteps() {
  return ['Computational Thinking Test', 'Platform Usability questions', 'Self efficacy'];
}

const hintsActivity1 = [
  { step: 'Computational Thinking Test'},
  { step: 'Platform Usability questions'},
  { step: 'Self efficacy' }
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};




export default function Hypothesis(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [isSubmit, setisSubmit] = React.useState(false);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes = styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState('panel1');
    const [gender, setgender] = React.useState('male');
    const [implement, setimplement] = React.useState('No'); 
    const [que1, setque1] = React.useState('');
    const [que2, setque2] = React.useState('IX');
    const [que3, setque3] = React.useState('');
    const [que4, setque4] = React.useState('');
    const [que5, setque5] = React.useState('');
    const [que6, setque6] = React.useState('');
    const [que7, setque7] = React.useState('');
    const [que8, setque8] = React.useState('');
    const [que9, setque9] = React.useState('');
    const [que10, setque10] = React.useState('');
    const [que11, setque11] = React.useState('');
    const [que12, setque12] = React.useState('');
    const [que13, setque13] = React.useState('');
    const [que14, setque14] = React.useState('');
    const [que15, setque15] = React.useState('');
    const [que16, setque16] = React.useState('');
    const [que17, setque17] = React.useState('');
    const [que18, setque18] = React.useState('');
    const [que19, setque19] = React.useState('');
    const [que20, setque20] = React.useState(''); 
    const [que21, setque21] = React.useState('');   
    const [que22, setque22] = React.useState('');   
    const [que23, setque23] = React.useState('');   
    const [que24, setque24] = React.useState('');   
    const [que25, setque25] = React.useState('');   
    const [que26, setque26] = React.useState('');   
    const [que27, setque27] = React.useState('');   
    const [que28, setque28] = React.useState('');   
    const [que29, setque29] = React.useState('');   
    const [que30, setque30] = React.useState('');   
    const [que31, setque31] = React.useState('');   
    const [que32, setque32] = React.useState('');   
    const [que33, setque33] = React.useState('');   
    const [que34, setque34] = React.useState('');   
    const [que35, setque35] = React.useState('');   
    const [que36, setque36] = React.useState('');   
    const [que37, setque37] = React.useState('');   
    const [que38, setque38] = React.useState('');   
    const [que39, setque39] = React.useState('');   
    const [que40, setque40] = React.useState('');
    const [que41, setque41] = React.useState('');
    const [que42, setque42] = React.useState('');
    const [que43, setque43] = React.useState('');
    const [que44, setque44] = React.useState('');
    const [que45, setque45] = React.useState('');
    const [que46, setque46] = React.useState('');
    const [que47, setque47] = React.useState('');
    const [que48, setque48] = React.useState('');
    const [que49, setque49] = React.useState('');
    const [que50, setque50] = React.useState('');
    const [que51, setque51] = React.useState('');   
    const [que52, setque52] = React.useState('');   
    const [que53, setque53] = React.useState('');   
    const [que54, setque54] = React.useState('');   
    const [que55, setque55] = React.useState('');   
    const [que56, setque56] = React.useState('');      
    const [mydata, setmydata] = React.useState('');
    const [mydeco, setmydeco] = React.useState('');
    const [mydeco1, setmydeco1] = React.useState('');
    const [mydeco2, setmydeco2] = React.useState('');
    const [mydeco3, setmydeco3] = React.useState('');
    const [self1, setself1] = React.useState('');
    const [self2, setself2] = React.useState('');
    const [self3, setself3] = React.useState('');
    const [self4, setself4] = React.useState('');
    const [self5, setself5] = React.useState('');
    const [self6, setself6] = React.useState('');
    const [self7, setself7] = React.useState('');
    const [self8, setself8] = React.useState('');
    const [self9, setself9] = React.useState('');
    const [self10, setself10] = React.useState('');
    const [self11, setself11] = React.useState('');
    const [self12, setself12] = React.useState('');
    const [self13, setself13] = React.useState('');
    const [self14, setself14] = React.useState('');
    const [self15, setself15] = React.useState('');
    const [self16, setself16] = React.useState('');
    const [self17, setself17] = React.useState('');
    const [self18, setself18] = React.useState('');
    const [patnum2, setpatnum2] = React.useState('');
    const [patnum3, setpatnum3] = React.useState('');
    const [patnum4, setpatnum4] = React.useState('');
    const [patnum5, setpatnum5] = React.useState('');
    const [patnum6, setpatnum6] = React.useState('');
    const [patnum7, setpatnum7] = React.useState('');
    const [patnum8, setpatnum8] = React.useState('');
    const [mypattern, setmypattern] = React.useState('');
    const [mypattern1, setmypattern1] = React.useState('');
    const [abs1, setabs1] = React.useState('');
    const [abs2, setabs2] = React.useState('');
    const [abs3, setabs3] = React.useState('');
    const [abs4, setabs4] = React.useState('');
    const [abs5, setabs5] = React.useState('');
    const [abs6, setabs6] = React.useState('');
    const [abs7, setabs7] = React.useState('');
    const [absNum, setabsNum] = React.useState('60');
    const [algo1, setalgo1] = React.useState('');
    const [algo2, setalgo2] = React.useState('');
    const [algo3, setalgo3] = React.useState('');
    const [algo4, setalgo4] = React.useState('');
    const [myalgo, setmyalgo] = React.useState('');
    const [myalgo1, setmyalgo1] = React.useState('');
    const [myalgo2, setmyalgo2] = React.useState('');
    const [myalgo3, setmyalgo3] = React.useState('');
    const [myalgo4, setmyalgo4] = React.useState('');
    const [myalgo5, setmyalgo5] = React.useState('');
    const [mybutton, setbutton] = React.useState('false');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [sollist, setsollist] = React.useState([]);
    const [wait, setwait] = React.useState(false);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(false);
    const [myModalTwo, setmyModalTwo] = React.useState(true);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [altHint, setaltHint] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')
    //const classes = styles1(theme)
    const [selectedDate, handleDateChange] = React.useState(new Date());
    const { classId, sesId } = useParams();


 

    useEffect(() => {



        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        console.log(classId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          axios.get(`${baseUrl}class/${classid}`, { cancelToken: source.token })
          .then((response) => {
          setclas(response.data)
          const dat = Array.from(response.data.sessions)
          axios.get(`${baseUrl}users/${user.id}`,config, { cancelToken: source.token })
          .then((response) =>{
          const dat = response.data;
          var em = dat.username;
          setloading(false)
            
          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((resp) =>{
            settotaldata(resp.data)        
            const activity = resp.data.activity1[0]
              setmydata(activity)

              if(resp.data.postTest[0].ibmsus!==""){
              var arr  = resp.data.postTest[0].ibmsus.split(';')
              setque37(arr[0])
              setque38(arr[1])
              setque39(arr[2])
              setque40(arr[3])
              setque41(arr[4])
              setque42(arr[5])
              setque43(arr[6])
              setque44(arr[7])
              setque45(arr[8])
              setque46(arr[9])
              setque47(arr[10])
              setque48(arr[11])
              setque49(arr[12])
              setque50(arr[13])
              setque51(arr[14])
              setque52(arr[15])
              setque53(arr[16])
              setque54(arr[17])
              setque55(arr[18])
              setque56(arr[19])   
                
            }
            if(resp.data.postTest[0].bebras!==''){
              console.log(resp.data.postTest[0].bebras)
              var arr = resp.data.postTest[0].bebras.split(',')
              //console.log(arr.length)
                setque6(arr[0])
                setque7(arr[1])
                setque8(arr[2])
                setque9(arr[3])
                setque10(arr[4])
                setque11(arr[5])
                setque12(arr[6])
                setque13(arr[7])
                setque14(arr[8])
                setque15(arr[9])
                setque16(arr[10])
                setque17(arr[11])
                setque18(arr[12])
                setque19(arr[13])
                setque20(arr[14])
                setque21(arr[15])
                setque22(arr[16])
                setque23(arr[17])
                setque24(arr[18])
                setque25(arr[19])
                setque26(arr[20])
                setque27(arr[21])
                setque28(arr[22])
                setque29(arr[23])
                setque30(arr[24])
                setque31(arr[25])
                setque32(arr[26])
                setque33(arr[27])
                setque34(arr[28])
                setque35(arr[29])
                setque36(arr[30])
            }

            getData(sessid)

              
            setloading(false)
            
          
          })
          .catch((error)=>{
            console.log(error);
            });
          })
          .catch((error)=>{
            console.log(error);
            });
          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })



 

  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
     const imageVariants = {
      animateOne:{
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  repeat: finalCount,
                  duration:3,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      },
      animateTwo:{
        x: [0, 499],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
      }
    }

   

     const imgVariants = {
      hidden:{ opacity: 0},
      visible:{
        opacity: 1,  
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  yoyo: myCount,
                  duration:1,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      }
    }

    
    


    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    
    const closeModalYesThree=()=>{
      
      var answerCorrect=false
      
      setmyModalThree(!myModalThree)
     
      
      if(activeStep==0){
        var err=true
        if(error==''){
          err=false
        }
        if(err===false){

          var ans = que6+','+que7+','+que8+','+que9+','+que10+','+que11+','+que12+','+que13+','+que14+','+que15+','+que16+','+que17+','+que18+','+que19+','+que20+
          ','+que21+','+que22+','+que23+','+que24+','+que25+','+que26+','+que27+','+que28+','+que29+','+que30+
          ','+que31+','+que32+','+que33+','+que34+','+que35+','+que36
          
          var score=0;
          ///que1
          if(que6==='Option3'){
            score = score+3
          }
          if(que7=='Option2'){
            score = score+3
          }///que2
          if(que8=='Option3'){
            score = score+6
          }//que3
          if(que9=='Option4'){
            score = score+2
          }
          if(que10=='Option2'){
            score = score+2
          }
          if(que11=='Option2'){
            score = score+2
          }//que4
          if(que12=='Option1'){
            score = score+2
          }
          if(que13==='Option3'){
            score = score+2
          }
          if(que14=='Option4'){
            score = score+2
          }//que5
          if(que15=='Option3'){
            score = score+3
          }
          if(que16==='Option2'){
            score = score+3
          }
          if(que17=='Option4'){
            score = score+3
          }
          ///que6
          if(que18==='Option3'){
            score = score+4.5
          }
          if(que19=='Option3'){
            score = score+4.5
          }///que7
          if(que20==='Option1'){
            score = score+3
          }
          if(que21=='Option2'){
            score = score+3
          }
          if(que22=='Option2'){
            score = score+3
          }///que8
          if(que23==='Option2'){
            score = score+4.5
          }
          if(que24=='Option1'){
            score = score+4.5
          }//que9
          if(que25=='Option3'){
            score = score+4
          }
          if(que26==='Option2'){
            score = score+4
          }
          if(que27=='Option3'){
            score = score+4
          }///que10
          if(que28==='Option1'){
            score = score+4
          }
          if(que29==='Option1'){
            score = score+4
          }
          if(que30=='Option3'){
            score = score+4
          }///que11
          if(que31=='Option3'){
            score = score+4
          }
          if(que32=='Option3'){
            score = score+4
          }
          if(que33=='Option2'){
            score = score+4
          }///que12
          if(que34=='Option2'){
            score = score+4
          }
          if(que35==='Option1'){
            score = score+4
          }
          if(que36=='Option3'){
            score = score+4
          }

          console.log('score '+score)
          console.log(ans)
          seterror('')
          totaldata.postTest[0].bebras=ans+','+score

             
        const data=
        {
          postTest: totaldata.postTest
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity1[0]
          setmydata(activity)
          settotaldata(response.data)                    
          
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          console.log('Going to'+activeStep) 
          setansType("Great work!! Let's move to next")

          setisSubmit(false)
          setmyModalTwo(!myModalTwo)    ////code for hints modal
          seterror('')

      })
      }
      else {
        setisSubmit(false)
      }     

      }

      if(activeStep==1){
        var err=true
        if(error==''){
          err=false
        }
        if(err===false){

          var ans = que37+';'+que38+';'+que39+';'+que40+';'+que41+';'+que42+';'+que43+';'+que44+';'+que45+';'+que46+';'+que47+';'+que48+';'+que49+';'+que50+';'+que51+';'+que52+';'+que53+';'+que54+';'+que55+';'+que56

          console.log(ans)
          seterror('')
          totaldata.postTest[0].ibmsus=ans
             
        const data=
        {
          postTest: totaldata.postTest
        }
                  
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity1[0]
        
          setmydata(activity) 
          settotaldata(response.data)  

          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          window.scrollTo(0, 0)
          console.log('Going to'+activeStep) 
          setansType("Correct Answer Bravo!! Let's move to next")

          setisSubmit(false)
          setmyModalTwo(!myModalTwo) ////code for hints modal
          seterror('')

      })
      }
      else{
        setisSubmit(false)
      }

      }

      if(activeStep==2){
        
      var err=true
      if(error==''){
        err=false
       }
        if(err===false){
          var ans = self1+','+self2+','+self3+','+self4+','+self5+','+self6+','+self7+','+self8+','+self9+','+self10+
          ','+self11+','+self12+','+self13+','+self14+','+self15+','+self16+','+self17+','+self18
    
          console.log(ans)
          seterror('')
          totaldata.postTest[0].efficacy=ans
          totaldata.postTest[0].completed=true
             
        const data=
        {
          postTest: totaldata.postTest
        }                     
          console.log(data)
                           
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity1[0]
          setmydata(activity)
          settotaldata(response.data)  
          history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activityfinal`)
          setansType("Correct Answer Bravo!! Let's move to next")
    
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')

        })

      }
      else{
        setisSubmit(false)
        seterror('Please enter text/number/operators in above space')
      }

    }      
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)
      setisSubmit(false)
    }

    


    // console.log(mydata.decomposition)

    function getStepContent(step) {
      switch (step) {
        case 0:
          return 'User information' ;
        case 1:
          return 'Computational Thinking Test';
        case 2:
          return 'self efficacy';
      }
    }

    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity1[0]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity)
           
  
      })
    
  }

  const movedat = (sou,dest,typ) =>{

    var dat = {
      source:sou,
      destination:dest,
      altStep:mydata.altStep,
      type:typ,
  
    }
    const data=
    {
      act:'activity1',
      moveData:dat
    }                     
    console.log(data)
  
  //   axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
  //   .then((response) => {
  //     console.log(response.data)
  //     const activity = response.data.activity1[0]
  //     setmydata(activity)
  // })
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false;

    if(activeStep==0 && totaldata.postTest[0].ibmsus!==''){
      
      console.log('Going next Completed initial form')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo(0, 0)
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
          if(totaldata.postTest[0].ibmsus!==''){
            
            var arr = totaldata.postTest[0].ibmsus.split(';')
            setque37(arr[0])
            setque38(arr[1])
            setque39(arr[2])
            setque40(arr[3])
            setque41(arr[4])
            setque42(arr[5])
            setque43(arr[6])
            setque44(arr[7])
            setque45(arr[8])
            setque46(arr[9])
            setque47(arr[10])
            setque48(arr[11])
            setque49(arr[12])
            setque50(arr[13])
            setque51(arr[14])
            setque52(arr[15])
            setque53(arr[16])
            setque54(arr[17])
            setque55(arr[18])
            setque56(arr[19])  
              
          }
            
      comp=true;
    }
    else if(activeStep==1 && totaldata.postTest[0].efficacy!==''){
      console.log('Going next Completed bebras')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      
      if(totaldata.postTest[0].efficacy!==''){
        console.log(totaldata.postTest[0].efficacy)
        var arr = totaldata.postTest[0].efficacy.split(',')
        //console.log(arr.length)
          setself1(arr[0])
          setself2(arr[1])
          setself3(arr[2])
          setself4(arr[3])
          setself5(arr[4])
          setself6(arr[5])
          setself7(arr[6])
          setself8(arr[7])
          setself9(arr[8])
          setself10(arr[9])
          setself11(arr[10])
          setself12(arr[11])
          setself13(arr[12])
          setself14(arr[13])
          setself15(arr[14])
          setself16(arr[15])
          setself17(arr[16])
          setself18(arr[17]) 
      }

      comp=true;

    }
    else if(activeStep==2 && totaldata.postTest[0].completed===true){
      
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activityfinal`)

      comp=true
      
    }
    
    console.log(activeStep)

   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
   }
   else{
     movedat(getStepContent(activeStep),getStepContent(activeStep+1),'completed')
   }  

  };

  const handleBack = () => {
    movedat(getStepContent(activeStep),getStepContent(activeStep-1),'completed')
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log('Going Back to '+activeStep)
    console.log(mydata)
////Code to update the text area when click back
    if(activeStep-1==0){
      
    }
    else if(activeStep-1==1){
      
    }
    else if(activeStep-1==2){
          
    }
    else if(activeStep-1==3){
    
    }
    else if(activeStep-1==4){
      
    }

  };

  const commaToText = (txt) =>{
    var mytext = ''
    if(txt!='' && typeof(txt)!=='undefined'){ 
    if(txt.includes(',')==true){
      var newArr = txt.split(',')
      var i=0
      while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
            mytext=mytext+' '+newArr[i]
            i=i+1
        }  
      
       return mytext
    }
    else{
      return txt
    }
  }
  return txt
    
 }

  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleClosePreview= () => {
        setopenBoard(!openBoard)
      }

      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }
   
    const handleQue1Change =(event)=> {
      setque1(event.target.value)
    }
    const handleQue2Change =(event)=> {
      setque2(event.target.value)
    }
    const handleQue3Change =(event)=> {
      setque3(event.target.value)
    }
    const handleQue4Change =(event)=> {
      setque4(event.target.value)
    }
    const handleQue5Change =(event)=> {
      setque5(event.target.value)
    }
    const handleQue6Change =(event)=> {
      setque6(event.target.value)
    }
    const handleQue7Change =(event)=> {
      setque7(event.target.value)
    }
    const handleQue8Change =(event)=> {
      setque8(event.target.value)
    }
    const handleQue9Change =(event)=> {
      setque9(event.target.value)
    }
    const handleQue10Change =(event)=> {
      setque10(event.target.value)
    }
    const handleQue11Change =(event)=> {
      setque11(event.target.value)
    }
    const handleQue12Change =(event)=> {
      setque12(event.target.value)
    }
    const handleQue13Change =(event)=> {
      setque13(event.target.value)
    }
    const handleQue14Change =(event)=> {
      setque14(event.target.value)
    }
    const handleQue15Change =(event)=> {
      setque15(event.target.value)
    }
    const handleQue16Change =(event)=> {
      setque16(event.target.value)
    }
    const handleQue17Change =(event)=> {
      setque17(event.target.value)
    }
    const handleQue18Change =(event)=> {
      setque18(event.target.value)
    }
    const handleQue19Change =(event)=> {
      setque19(event.target.value)
    }
    const handleQue20Change =(event)=> {
      setque20(event.target.value)
    }
    const handleQue37Change =(event)=> {
        setque37(event.target.value)
      }
      const handleQue38Change =(event)=> {
        setque38(event.target.value)
      }
      const handleQue39Change =(event)=> {
        setque39(event.target.value)
      }  
    const handleQue40Change =(event)=> {
        setque40(event.target.value)
      }
      const handleQue41Change =(event)=> {
        setque41(event.target.value)
      }
      const handleQue42Change =(event)=> {
        setque42(event.target.value)
      }
      const handleQue43Change =(event)=> {
        setque43(event.target.value)
      }
      const handleQue44Change =(event)=> {
        setque44(event.target.value)
      }
      const handleQue45Change =(event)=> {
        setque45(event.target.value)
      }
      const handleQue46Change =(event)=> {
        setque46(event.target.value)
      }
      const handleQue47Change =(event)=> {
        setque47(event.target.value)
      }
      const handleQue48Change =(event)=> {
        setque48(event.target.value)
      }
      const handleQue49Change =(event)=> {
        setque49(event.target.value)
      }
      const handleQue50Change =(event)=> {
        setque50(event.target.value)
      }
      const handleQue51Change =(event)=> {
        setque51(event.target.value)
      }
      const handleQue52Change =(event)=> {
        setque52(event.target.value)
      }
      const handleQue53Change =(event)=> {
        setque53(event.target.value)
      }
      const handleQue54Change =(event)=> {
        setque54(event.target.value)
      }
      const handleQue55Change =(event)=> {
        setque55(event.target.value)
      }
      const handleQue56Change =(event)=> {
        setque56(event.target.value)
      }
    const handleSelf1Change =(event)=> {
      setself1(event.target.value)
    }
    const handleSelf2Change =(event)=> {
      setself2(event.target.value)
    }
    const handleSelf3Change =(event)=> {
      setself3(event.target.value)
    }
    const handleSelf4Change =(event)=> {
      setself4(event.target.value)
    }
    const handleSelf5Change =(event)=> {
      setself5(event.target.value)
    }
    const handleSelf6Change =(event)=> {
      setself6(event.target.value)
    }
    const handleSelf7Change =(event)=> {
      setself7(event.target.value)
    }
    const handleSelf8Change =(event)=> {
      setself8(event.target.value)
    }
    const handleSelf9Change =(event)=> {
      setself9(event.target.value)
    }
    const handleSelf10Change =(event)=> {
      setself10(event.target.value)
    }
    const handleSelf11Change =(event)=> {
      setself11(event.target.value)
    }
    const handleSelf12Change =(event)=> {
      setself12(event.target.value)
    }
    const handleSelf13Change =(event)=> {
      setself13(event.target.value)
    }
    const handleSelf14Change =(event)=> {
      setself14(event.target.value)
    }
    const handleSelf15Change =(event)=> {
      setself15(event.target.value)
    }
    const handleSelf16Change =(event)=> {
      setself16(event.target.value)
    }
    const handleSelf17Change =(event)=> {
      setself17(event.target.value)
    }
    const handleSelf18Change =(event)=> {
      setself18(event.target.value)
    }
    
    
      
   
      const CalculateOddSum=()=>{
        var code=''
        if(absNum!=='' && typeof(absNum)!='undefined'){
            code=`n=${absNum}; return n`
        }    
        if(absNum!=='' && typeof(absNum)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs2)!='undefined' && typeof(abs3)!='undefined'){
            code=`n=${absNum}; sum = (${abs1}${abs2}${abs3}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
            code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
          code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}${abs6}${abs7}); return sum`
      }
        const F = new Function(code);  
        var out = F()
        return out
    }

      const SuSForm = () => {
        var err='';
        var mycode=''
        if(que37===''){
            err='Please complete question1'
          }
          else if(que38===''){
            err='Please complete question2'
          }
          else if(que39===''){
            err='Please complete question3'
          }
          else if(que40===''){
            err='Please complete question4'
          }
          else if(que41===''){
            err='Please complete question5'
          }
          else if(que42===''){
            err='Please complete question6'
          }
          else if(que43===''){
            err='Please complete question7'
          }
          else if(que44===''){
            err='Please complete question8'
          }
          else if(que45===''){
            err='Please complete question9'
          }
          else if(que46===''){
            err='Please complete question10'
          }
        
        seterror(err)
      }
      
      const BebrasForm = () => {
        var err='';
        
        if(que6===''|| que7===''){
          err='Please complete all subquestions in question1'
        }
        else if( que8===''){
          err='Please complete all subquestions in question2'
        }
        else if(que9===''|| que10===''|| que11===''){
          err='Please complete all subquestions in question3'
        }
        else if( que12===''|| que13===''|| que14===''){
          err='Please complete all subquestions in question4'
        }
        else if(que16===''|| que17===''|| que15==='' ){
          err='Please complete all subquestions in question5'
        }
        else if( que18===''|| que19===''){
          err='Please complete all subquestions in question6'
        }
        else if(que20===''|| que21===''|| que22===''){
          err='Please complete all subquestions in question7'
        }
        else if(que23===''|| que24===''){
          err='Please complete all subquestions in question8'
        }
        else if(que26===''|| que27===''|| que25===''){
          err='Please complete all subquestions in question9'
        }
        else if(que29===''|| que30==='' ||  que28===''){
          err='Please complete all subquestions in question10'
        }
        else if(que31===''|| que32===''|| que33===''){
          err='Please complete all subquestions in question11'
        }
        else if(que35==='' || que36===''|| que34===''){
          err='Please complete all subquestions in question12'
        }
        
        seterror(err)
      }
      
     
      const EfficacyForm = () => {
        var err='';
        
        if(self1===''){
          err='Please complete question1'
        }
        else if(self2===''){
          err='Please complete question2'
        }
        else if(self3===''){
          err='Please complete question3'
        }
        else if(self4===''){
          err='Please complete question4'
        }
        else if(self5===''){
          err='Please complete question5'
        }
        else if(self6===''){
          err='Please complete question6'
        }
        else if(self7===''){
          err='Please complete question7'
        }
        else if(self8===''){
          err='Please complete question8'
        }
        else if(self9===''){
          err='Please complete question9'
        }
        else if(self10===''){
          err='Please complete question10'
        }
        else if(self11===''){
          err='Please complete question11'
        }
        else if(self12===''){
          err='Please complete question12'
        }
        else if(self13===''){
          err='Please complete question13'
        }
        else if(self14===''){
          err='Please complete question14'
        }
        else if(self15===''){
          err='Please complete question15'
        }
        else if(self16===''){
          err='Please complete question16'
        }
        else if(self17===''){
          err='Please complete question17'
        }
        else if(self18===''){
          err='Please complete question18'
        }
        
        seterror(err)
      }


      const handleAlgorithmChange =( event )=> {
        setmyalgo(event.target.value)
      }

      const handleAlgorithmChange1 =( event )=> {
        setmyalgo1(event.target.value)
      }

      const handleAlgorithmChange2 =( event )=> {
        setmyalgo2(event.target.value)
      }

      const handleAlgorithmChange3 =( event )=> {
        setmyalgo3(event.target.value)
      }
      
      const handleAlgorithmChange4 =( event )=> {
        setmyalgo4(event.target.value)
      }

      const handleAlgorithmChange5 =( event )=> {
        setmyalgo5(event.target.value)
      }
      const compareSolutionChange =( event )=> {
        setmycomsol(event.target.value)
      }
      const compareSolutionChange1 =( event )=> {
        setmycomsol1(event.target.value)
      }
      const compareSolutionChange2 =( event )=> {
        setmycomsol2(event.target.value)
      }
      const compareSolutionChange3 =( event )=> {
        setmycomsol3(event.target.value)
      }

      const handleSpaceChange =( event )=> {
        setmyspace(event.target.value)
      }

      const handleTimeChange =( event )=> {
        setmytime(event.target.value)
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }

      const buttonSelect = (k,que) =>{
        var mysol='Option'+k
        console.log(k)
        console.log(que)
        console.log(que6)
        if(que==6){
            console.log('Matched')
          setque6(mysol)
        }
        else if(que==7){
            setque7(mysol)
        }
        else if(que==8){
            setque8(mysol)
        }
        else if(que==9){
            setque9(mysol)
        }
        else if(que==10){
            setque10(mysol)
        }
        else if(que==11){
            setque11(mysol)
        }
        else if(que==12){
            setque12(mysol)
        }
        else if(que==13){
            setque13(mysol)
        }
        else if(que==14){
            setque14(mysol)
        }
        else if(que==15){
            setque15(mysol)
        }
        else if(que==16){
            setque16(mysol)
        }
        else if(que==17){
            setque17(mysol)
        }
        else if(que==18){
            setque18(mysol)
        }
        else if(que==19){
            setque19(mysol)
        }
        else if(que==20){
            setque20(mysol)
        }
        else if(que==21){
            setque21(mysol)
        }
        else if(que==22){
            setque22(mysol)
        }
        else if(que==23){
            setque23(mysol)
        }
        else if(que==24){
            setque24(mysol)
        }
        else if(que==25){
            setque25(mysol)
        }
        else if(que==26){
            setque26(mysol)
        }
        else if(que==27){
            setque27(mysol)
        }
        else if(que==28){
            setque28(mysol)
        }
        else if(que==29){
            setque29(mysol)
        }
        else if(que==30){
            setque30(mysol)
        }
        else if(que==31){
            setque31(mysol)
        }
        else if(que==32){
            setque32(mysol)
        }
        else if(que==33){
            setque33(mysol)
        }
        else if(que==34){
            setque34(mysol)
        }
        else if(que==35){
            setque35(mysol)
        }
        else if(que==36){
            setque36(mysol)
        }
        else if(que==37){
            setque37(mysol)
        }

      }

      const MCQAnswers =(type, quenum, stat, option1, option2, option3, option4)=>{

        //console.log(stat['que'+quenum])
         //console.log(quenum) 
         if(type=='row'){   
          return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                
                        <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option </b>
                        <CardBody>
                            <b style={classes.ana}> {option1} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option </b>
                        <CardBody>
                            <b style={classes.ana}> {option2} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option </b>
                        <CardBody>
                            <b style={classes.ana}> {option3} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option </b>
                        <CardBody>
                            <b style={classes.ana}> {option4} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
            </GridContainer>               
            );
          }
          else if(type=='col'){   
            return (
              <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                  
                          <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option </b>
                          <CardBody>
                              <b style={classes.ana}> {option1} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option </b>
                          <CardBody>
                              <b style={classes.ana}> {option2} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option </b>
                          <CardBody>
                              <b style={classes.ana}> {option3} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option </b>
                          <CardBody>
                              <b style={classes.ana}> {option4} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
              </GridContainer>               
              );
            }
            else if(type=='2x2'){   
                return (
                  <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                      
                              <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option </b>
                              <CardBody>
                                  <b style={classes.ana}> {option1} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option </b>
                              <CardBody>
                                  <b style={classes.ana}> {option2} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option </b>
                              <CardBody>
                                  <b style={classes.ana}> {option3} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option </b>
                              <CardBody>
                                  <b style={classes.ana}> {option4} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                  </GridContainer>               
                  );
                }
        }



const solutionComparison =(algorithm,analysis,len,k)=>{

  const algoText = (txt) =>{
    var tex = txt.split(';')
    return (<div>
        {tex.length==4?
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                 {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                 {commaToText(tex[1])} 
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[3])}
            </GridItem>
        </GridContainer>:
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[1])} {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[3])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[4])}
            </GridItem>
        </GridContainer>}
        </div>
    )
  }
    return (
        <>
        <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
          <Card  onClick={() => buttonSelect(len,k)} hoverable sx={k=='1'?{backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                <b align="center">(other possible solutions) Solution {len}</b>
            <CardBody>
              <b style={classes.ana}> Algorithm </b>
              <p style={classes.cardTitle}>{algoText(algorithm)}</p>
              <b style={classes.ana}> Analysis </b>
              <p style={classes.cardCategory}>
                {analysis} 
              </p>
            </CardBody>
          </Card>
        </Link>
         
        {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
              <>
                <h5>Answer 1. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol1}
                    onChange={compareSolutionChange1}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
            {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
        </>            
        );
      }
    


const submitPatternForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      var ans = que6+','+que7+','+que8+','+que9+','+que10+','+que11+','+que12+','+que13+','+que14+','+que15+','+que16+','+que17+','+que18+','+que19+','+que20+
          ','+que21+','+que22+','+que23+','+que24+','+que25+','+que26+','+que27+','+que28+','+que29+','+que30+
          ','+que31+','+que32+','+que33+','+que34+','+que35+','+que36

          var score=0;
          ///que1
          if(que6==='Option3'){
            score = score+3
          }
          if(que7=='Option2'){
            score = score+3
          }
          if(que8=='Option3'){
            score = score+6
          }///que2
          if(que9=='Option4'){
            score = score+2
          }
          if(que10=='Option2'){
            score = score+2
          }
          if(que11=='Option2'){
            score = score+2
          }
          if(que12=='Option1'){
            score = score+2
          }///que3
          if(que13==='Option3'){
            score = score+2
          }
          if(que14=='Option4'){
            score = score+2
          }
          if(que15=='Option3'){
            score = score+3
          }///que4
          if(que16==='Option2'){
            score = score+3
          }
          if(que17=='Option4'){
            score = score+3
          }
          ///que5
          if(que18==='Option3'){
            score = score+4.5
          }
          if(que19=='Option3'){
            score = score+4.5
          }///que6
          if(que20==='Option1'){
            score = score+3
          }
          if(que21=='Option2'){
            score = score+3
          }
          if(que22=='Option2'){
            score = score+3
          }///que7
          if(que23==='Option2'){
            score = score+4.5
          }
          if(que24=='Option1'){
            score = score+4.5
          }
          if(que25=='Option3'){
            score = score+4
          }///que8
          if(que26==='Option2'){
            score = score+4
          }
          if(que27=='Option3'){
            score = score+4
          }///que9
          if(que28==='Option1'){
            score = score+4
          }///que10
          if(que29==='Option1'){
            score = score+4
          }
          if(que30=='Option3'){
            score = score+4
          }///que11
          if(que31=='Option3'){
            score = score+4
          }
          if(que32=='Option3'){
            score = score+4
          }
          if(que33=='Option2'){
            score = score+4
          }
          if(que34=='Option2'){
            score = score+4
          }///que12
          if(que35==='Option1'){
            score = score+4
          }
          if(que36=='Option3'){
            score = score+4
          }

          console.log('score '+score)
          console.log(ans)
          seterror('')
          totaldata.postTest[0].bebras=ans+','+score
             
        const data=
        {
          postTest: totaldata.postTest
        }                    
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
        
    })
  
}


const submitAbstractionForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      var ans = self1+','+self2+','+self3+','+self4+','+self5+','+self6+','+self7+','+self8+','+self9+','+self10+
      ','+self11+','+self12+','+self13+','+self14+','+self15+','+self16+','+self17+','+self18

      console.log(ans)
      seterror('')
      totaldata.postTest[0].efficacy=ans
         
    const data=
    {
      postTest: totaldata.postTest
    }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  //}
}

const submitAlgorithmForm = () =>{
  const algo = myalgo;                     
  var empty = true;
  if(myalgo !== ''|| myalgo1 !== ''|| myalgo2 !== ''|| myalgo3 !== ''|| myalgo4 !== ''|| myalgo5 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter your text')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.abstraction[0].completed===false){
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
      
      }
      else{
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
        
      }

      const data=
      {
        act:'activity1',
        algorithm:mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}

const submitAnalysisForm = () =>{
  var empty = true;
  if(myspace !== '' && mytime !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter a number')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.analysis[0].spaceText=myspace
      mydata.analysis[0].timeText=mytime

      const data=
      {
        act:'activity1',
        analysis:mydata.analysis
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}

const submitComparisonForm = () =>{
  var empty = true;
  if(mycomsol !== '' && mycomsol2 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter text above')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
            mydata.comparison[0].userText='Which of the solutions do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='You system can perform only maximum 5 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3

      const data=
      {
        act:'activity1',
        comparison:mydata.comparison
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}


const history = useNavigate();



const hintGenerate =()=>{
  return(
    <div>
                          {hintsActivity1.map((text, index)=>(
                              index===activeStep?
                                <div>
                                  <CardHeader color="success" align="center">
                                    <Typography variant="subtitle2" align="center" sx={classes.cardTitleWhite}>Hints {hintsActivity1[index].step}</Typography>
                                  </CardHeader>
                                  <List sx={classes.messageArea}>
                                    {index===0 && 
                                      mydata.decomposition[0].levelOfHints==='Basic' || index==0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>Basic </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].basic}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                      {index===0 && mydata.decomposition[0].levelOfHints==='Advanced' || index==0 && mydata.decomposition[0].levelOfHints==='Intermediate'?
                                      <div>
                                      <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Intermediate</Typography>
                                          {/* <Typography sx={classes.secondaryHeading}>Hints </Typography> */}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                         {mydata.decomposition[0].hints[0].intermediate}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                      {index===0 && mydata.decomposition[0].levelOfHints==='Advanced'?<div>
                                      <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Advanced</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {mydata.decomposition[0].hints[0].advanced}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                    {index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index===1 && mydata.pattern[0].levelOfHints==='Advanced' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate'?
                                  < div>
                                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Intermediate</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].intermediate}
                                      </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===1 && mydata.pattern[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.pattern[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===2 && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  {index===2 && mydata.abstraction[0].levelOfHints==='Advanced' || index===2 && mydata.abstraction[0].levelOfHints==='Intermediate'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==2 && mydata.abstraction[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && mydata.algorithm[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].intermediate}
                                           
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Basic' || index==4 && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && mydata.analysis[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>: null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div> :null}
                                  </List>
                                 </div>
                                :null))}                  
              
                              </div>
  )
}

//console.log(Num)
//console.log('Deco:'+mydeco)

const InputFeedback = ({ error }) =>
  error ? <div style={classNames("input-feedback")}>{error}</div> : null;

// Radio input
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  ...props
}) => {
  return (
    <div>
      <input
        name={name}
        id={id}
        type="radio"
        value={id} // could be something else for output?
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        className={classNames("radio-button")}
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

// Radio group
const RadioButtonGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  children
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <div style={classes}>
      <fieldset>
        <h5>{label}</h5>
        {children}
        {touched && <InputFeedback error={error} />}
      </fieldset>
    </div>
  );
};


    return(
    loading!==true?
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>                                        
                <Typography color="textPrimary">Post Test</Typography>
            </Breadcrumbs>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
            <Typography variant="h5" className="header-message" align="center">
              Test Questions 
            </Typography>
          </GridItem>
        </GridContainer>
        {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                    <GridContainer> 
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <motion.div style={classes.modal1}>
                          <h5 style={classes.fontCursive}>Read the Instructions carefully.</h5>
                          <h5 style={classes.fontCursive}> Solve the problem to complete the activity and move forward in your mission.</h5>
                        </motion.div>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}

                  <Formik                  
                    initialValues={{
                    gender: gender,
                    implement:implement,
                    que6:que6,
                    que7:que7,
                    que8:que8,
                    que9:que9,
                    que10:que10,
                    que11:que11,
                    que12:que12,
                    que13:que13,
                    que14:que14,
                    que15:que15,
                    que16:que16,
                    que17:que17,
                    que18:que18,
                    que19:que19,
                    que20:que20,
                    que21:que21,
                    que22:que22,
                    que23:que23,
                    que24:que24,
                    que25:que25,
                    que26:que26,
                    que27:que27,
                    que28:que28,
                    que29:que29,
                    que30:que30,
                    que31:que31,
                    que32:que32,
                    que33:que33,
                    que34:que34,
                    que35:que35,
                    que36:que36,
                    }}

                    onSubmit={(values, {setSubmitting}) => {
                      setTimeout(() => {
                      setSubmitting(false);
                      alert(JSON.stringify('Saving...', null, 2));
                                            
                      var ans = que37+';'+que38+';'+que39+';'+que40+';'+que41+';'+que42+';'+que43+';'+que44+';'+que45+';'+que46+';'+que47+';'+que48+';'+que49+';'+que50+';'+que51+';'+que52+';'+que53+';'+que54+';'+que55+';'+que56

                      console.log(ans)
                        seterror('')
                       totaldata.postTest[0].ibmsus=ans

                        const data=
                        {
                          postTest: totaldata.postTest
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity1[0]
                          setmydata(activity)
                      })
                     }, 500);
                    }}
                >

       

          {({submitForm, values, isSubmitting, touched, errors}) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Form>
          {loading!==true?

            <GridContainer>
             
                {/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}

        

    {hintsActivity1.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                     
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <GridContainer>
                          <motion.div style={classes.modal1}>
                            <h5 style={ansType.includes('Correct Answer')==true?{color:'green'}:{color:'red'}}> {ansType} </h5>
                              <Typography variant="subtitle1">{altHint}</Typography>
                            <h5 style={classes.fontMonaco}> Current Step: {hintsActivity1[index].step} 
                            </h5>
                            <h5 style={classes.fontGaramond}> Your Task: {task[activeStep]}</h5>  
                          </motion.div>
                        </GridContainer>
                      </GridItem>
                    </GridContainer>
                          <Button color="success" variant="contained" onClick={closeModalTwo} 
                            title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                              OK
                          </Button>
                    </motion.div>
                     
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal2}
                    variants={modal} 
                    >
                      <GridContainer>
                        {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='Marine Life' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9}>
                          <motion.div style={classes.modal2}>
                            <h4 style={classes.fontGaramond}> Are you sure you want to submit </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                No
                            </Button>
                          </motion.div>
                        </GridItem>
                      </GridContainer>
                    
                    </motion.div>  
                </motion.div>
              </AnimatePresence>)}
            <GridItem xs={12} sm={12} md={12}>
              
                <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {steps.map((step, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel><h5 style={classes.fontLucida}>{step}</h5></StepLabel>
                      </Step>
                      );
                      })}
                    </Stepper>
                  </GridItem>
                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                    <h5 style={{...classes.fontCourier, ...{color:'blue'}}}><b>Important Instructions:</b> Read the questions carefully and enter your answers accordingly</h5>
                      {activeStep=='0' ?   //////Decomposition
                      <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                        <h5 style={classes.fontCourier}><b> About the Test: </b> The test is used to assess the computational thinking skills of the user. Every question has a particular story with single/multiple subquestions. 
                        The subquestions are of multiple choice type with single correct answer. Read each question and answer all subquestions to move to the final step. Click on the card to select the answer.</h5>
                          <GridContainer>  
                              <b>{error!=''?'error: '+error:''}</b>    
                              <GridItem xs={12} sm={12} md={12}>
                              <Accordion expanded={expanded1 === 'panel1'} onChange={handleAccordionChange1('panel1')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>1. Select a Picture </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails>
                                <Card>
                                  <CardHeader color="success">
                                    <h4 style={classes.cardTitleWhite}>{task[1]}</h4>
                                    <h4>1. Select a Picture</h4>
                                  </CardHeader>
                                  <p><i>{ansType}</i></p>
                                    
                                  <CardBody>
                                    <GridContainer>
      {/*....................................... Question1 .....................................*/}
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <p>Johnny has 8 photos. He wants to give one to Bella.</p>
                                          <p>He asks Bella three questions to help him select the best picture.</p>
                                          <p><b>Johnny's Question</b>.................................................................<b>Bella's Answer</b></p>
                                          <p>1. Do you want a photo with a beach umbrella? ............................<span><b>Yes</b></span></p>
                                          <p>2. Do you want a photo where I wear something on my head?<span><b>......No</b></span></p>
                                          <p>3. Do you want a photo where you can see the sea?.................<span><b>Yes</b></span></p>
                                        
                                        <p> Answer the below questions to select photo for Bella.</p>
                                          
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={4}>
                                            <img alt='bebimage68' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/bebimg68.PNG'} />
                                        
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={8}>
                                        <h5>Q1.1. Select the correct options with objects and correct name in photo: </h5>
                                        {MCQAnswers('2x2', 6,{que6},
                                        <img alt='bebimage69' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg69.PNG'} />
                                        ,<img alt='bebimage70' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg70.PNG'} />
                                        ,<img alt='bebimage71' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg71.PNG'} />
                                        ,<img alt='bebimage72' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg72.PNG'} />
                                        )}
                                     
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={8}>
                                            <h5>Q1.2. Select the correct photo for bella based on the above questions:</h5>
                                            Select among below options:
                                            {MCQAnswers('2x2', 7,{que7},
                                              <img alt='bebimage73' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg73.PNG'} />,
                                              <img alt='bebimage74' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg74.PNG'} />,
                                              <img alt='bebimage75' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg75.PNG'} />,
                                              <img alt='bebimage76' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg76.PNG'} />
                                                )}
                                      </GridItem>                              
                                  </GridContainer>
                                </CardBody>
                              </Card> 
                              </AccordionDetails>
                            </Accordion> 
{/*............................................... Question2 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel2'} onChange={handleAccordionChange1('panel2')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>2. Tube System </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails>    
                              <Card>
                                <CardHeader color="success">
                                  <h4>2. Tube System</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer> 
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage77' className="card-img-top" src={baseUrl+'assets/images/bebimg77.PNG'} />
                                        <h5>Answer the questions in the right hand side:</h5>
                                        <br />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h5>2.1. In which tube should the mouse start so that it reaches the cheese?</h5>
                                        Select among below options:
                                        {MCQAnswers('row', 8,{que8},2,3,4,5)}
                                      </GridItem>
                                         
                                  </GridContainer>
                                </CardBody> 
                              </Card>
                              </AccordionDetails>
                              </Accordion>                                                                           
{/*............................................... Question3 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel3'} onChange={handleAccordionChange1('panel3')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>3. News editing </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>3. News editing</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>   
                                          <img alt='bebimage78' className="card-img-top" src={baseUrl+'assets/images/bebimg78.PNG'} />
                                          <h5>Answer the questions in the right hand side and below:</h5>
                                            <br />
                                        </GridItem>
                                        
                                      </GridContainer>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q3.1. Count the students working around 12:00? Observe the red cells</h5>
                                              {MCQAnswers('row', 9,{que9},'3','5','2','4' )}
                                              
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>3.2. Select the time at which maximum students are working on the computer?</h5>
                                              {MCQAnswers('row', 10,{que10},'8:00','9:00',
                                              '11:00','13:00' )}
                                              
                                          </GridItem>
                                        
                                      
                                        
                                      </GridContainer>
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>       
                                      <h5>Q3.3. What is the minimum number of computers needed for all of the students to work according to the plan shown above?</h5>
                                      {MCQAnswers('row', 11,{que11},'4','5','6','7' )}
                                              
                                          </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question4 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>4. Five sticks </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>4. Five sticks</h4>
                                </CardHeader>                
                                <CardBody>
                                  <GridContainer>
                                      
                                      <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage79' className="card-img-top" src={baseUrl+'assets/images/bebimg79.PNG'} />
                                        <h5>. 
                                          Based on the above information, Answer the questions below:</h5>
                                          <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>

                                     
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q4.1. Which stick did Nola changed from Adam’s shape? Select the correct one </h5>
                                          {MCQAnswers('row', 12,{que12},
                                            <img alt='bebimage80' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg80.PNG'} />
                                            ,<img alt='bebimage81' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg81.PNG'} />
                                            ,<img alt='bebimage82' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg82.PNG'} />
                                            ,'None of the above'
                                            )}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>

                                     
                                      <GridItem xs={12} sm={12} md={6}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q4.2. If Bob wants to make the shape on the right,which stick should be changed from Nola's shape? Select the correct option</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage83' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg83.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                          
                                            {MCQAnswers('row', 13,{que13},
                                            <img alt='bebimage84' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg84.PNG'} />
                                            ,<img alt='bebimage85' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg85.PNG'} />
                                            ,<img alt='bebimage86' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg86.PNG'} />
                                            ,'None of the above'
                                            )}
                                          
                                        </GridItem>
                                       
                                     
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q4.3. Select the shape Bob won't be able to make:</h5>
                                            {MCQAnswers('row', 14,{que14},
                                            <img alt='bebimage87' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg87.PNG'} />
                                            ,<img alt='bebimage88' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg88.PNG'} />
                                            ,<img alt='bebimage89' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg89.PNG'} />
                                            ,<img alt='bebimage90' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg90.PNG'} />
                                            )}
                                        </GridItem>
                                        
                                        
                                    
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                            </Accordion> 
{/*............................................... Question5 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel5'} onChange={handleAccordionChange1('panel5')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>5. One too many </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>5. Passcode</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <h4>5. One too many</h4>
                                        <p>I recently discovered a silly mistake I made in a long piece of alphanumeric text.</p>
                                          All 1's should be 11's and all 11's should be 1's. Luckily, I can be rather smart and I have an
                                          editor which enables me to replace a sequence of characters with another sequence.
                                        <p>See what happops in a soptopce in which I replace all occuropces (except the last one)
                                        of en with op!</p>
                                        Of, wofse, feplacing all occuffences of r (except the last one) with f.
                                        <h5> 
                                          Answer the questions in the right hand side and help me to fix my text:</h5>
                                          <br />
                                          
                                        
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q5.1. Select the new text when you replace ‘1’ by 11 and ‘11’ by 1 in 81911541161?</h5>
                                      {MCQAnswers('2x2', 15,{que15},'81191541161','81915411611','81191541611','None of the above' )}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5>Q5.2. Can you identify the original text when en is replaced by op in ‘See what happops in a soptopce in which I replace all occuropces’?</h5>
                                        {MCQAnswers('row', 16,{que16},'See what happens in a soptence in which I replace all occurences',
                                        'See what happens in a sentence in which I replace all occurences',
                                        'See what happens in a sentence in which I replace all occurces',
                                        'None of the  above' )}  
                                   
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q5.3. In my text above there was a mistake where All 1’s should be 11’s and all 11’s should be 1’s. I have an editor which can replace a sequence of character with another sequence. 
                                          What should I do to fix the text?:</h5>
                                        {MCQAnswers('row', 17,{que17},'Replace all 11’s with 1’s and all 1’s with 11’s',
                                        'Replace all 1’s with 11’s and all 11’s with 1’s',
                                        'Replace all 1’s with $s and all $s with 11’s and then all 11’s with 1’s',
                                        'Replace all 11’s with $s and all 1’ with 11’s and then all $s with 1’s' )} 
                                      </GridItem>  
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                          </Accordion>
{/*............................................... Question6 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>6. Loading Lisas </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>6. Loading Lisas</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}> 
                                        <p>Two fishermen own two boats, named "Lisa 1" and "Lisa 2". Each boat can hold a maximum cargo of 300kg.</p>
                                        <p>The fishermen are given barrels filled with fish to transport. On each barrel is a number that shows how heavy the barrel is in kilograms.</p>
                                        You must make sure that neither boat is overloaded.
                                        <p>Divide the barrels into two boats so that the maximum possible load of fish is carried</p>
                                        <img alt='bebimage91' className="card-img-top" src={baseUrl+'assets/images/bebimg91.PNG'} />
                                        <h5> 
                                          With the information given above, Answer the questions in the right hand side and below:</h5>
                                          <br />                                               
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q6.1. Select barrels with total load closest to 300 and less than 300.
                                               Add numbers to calculate load:</h5>
                                          {MCQAnswers('2x2', 18,{que18},
                                            <img alt='bebimage92' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg92.PNG'} />
                                            ,<img alt='bebimage93' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg93.PNG'} />
                                            ,<img alt='bebimage94' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg94.PNG'} />
                                            ,<img alt='bebimage95' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg95.PNG'} />
                                            )}  
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q6.2. Divide the barrels into two boats so that maximum possible load of fish is carried:</h5>
                                        {MCQAnswers('2x2', 19,{que19},
                                              <img alt='bebimage96' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg96.PNG'} />
                                            ,<img alt='bebimage97' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg97.PNG'} />
                                            ,<img alt='bebimage98' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg98.PNG'} />
                                            ,'None of the above'
                                            )}
                                    </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                          </Accordion>
{/*............................................... Question7 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>7. Magic potions </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>7. Magic potions</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage99' className="card-img-top" src={baseUrl+'assets/images/bebimg99.PNG'} />
                                        <h5> 
                                          With the information about the experiment given above, Answer the questions in the right hand side and below:</h5>
                                         
                                          <br />

                                       

                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                         <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q7.1. Identify the effect on beaver in exp1-? Select the correct option</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage102' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg102.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                            {MCQAnswers('2x2', 20,{que20},'long ear, long teeth, white nose',
                                            'long ear, long teeth',
                                            'long ear, long teeth, white eyes',
                                            'None of the  above'
                                            )}
                                          
                     
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                        <GridContainer>
                                              <GridItem xs={12} sm={12} md={6}>
                                                  <h5>Q7.2. Identify the common effect and beaker between exp1-exp2</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage100' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg100.PNG'} />
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={6}>
                                                  <h5>Also find the common effect and beaker between exp2- exp3</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage101' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg101.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                            {MCQAnswers('row', 21,{que21},
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long ear and between (exp2-exp3)-->Beaker D,long teeth',
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long ear and between (exp2-exp3)-->Beaker D, nothing',
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long teeth and between (exp2-exp3)--> Beaker D, long ear',
                                              'None of the  above'
                                              )}
                                       <h5>Q7.3. Which beaker contains pure water?</h5>      
                                          {MCQAnswers('row', 22,{que22},
                                                  'E',
                                                  'D',
                                                  'C',
                                                  'None of the  above'
                                                  )}
                                    </GridItem>

                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question8 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel8'} onChange={handleAccordionChange1('panel8')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>8. Bus stop </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>8. Bus stop</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        
                                        <img alt='bebimage103' className="card-img-top" src={baseUrl+'assets/images/bebimg103.PNG'} />
                                           <h5> 
                                              With the information given above, Answer the questions in the right hand side and below to identify the location for bus stop:
                                          </h5>
                                          <br />
                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Q8.1. Find the distance from beaver1, beaver2, beaver3, beaver4, beaver5 to bus stop. Calculate the total distance between beaver’s lodges and bus stop:</h5>
                                          <img alt='bebimage104' className="card-img-top" src={baseUrl+'assets/images/bebimg104.PNG'} />
                                        {MCQAnswers('2x2', 23,{que23},'120','130','90','100' )}       
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}> 
                                             
                                      <h5>Q8.2. Select the best place for the bus stop (Marked with black dot):</h5>
                                            Select among below options:
                                            {MCQAnswers('2x2', 24,{que24},
                                              <img alt='bebimage105' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg105.PNG'} />,
                                              <img alt='bebimage106' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg106.PNG'} />,
                                              <img alt='bebimage107' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg107.PNG'} />,
                                              <img alt='bebimage108' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg108.PNG'} />

                                                )}
                                    </GridItem>  
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                            </Accordion> 
{/*............................................... Question9 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>9. Mobile phones </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                <h4>9. Mobile phones</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        
                                        <p>The beaver family have three mobile phones but none of the batteries have any charge.</p>
                                        <p>It takes 1 hour to fully charge a mobile phone but this does not need to be done all in one go.</p>
                                        <h5> The beaver family only have two mobile phone chargers in the house. Answer the questions below related to the above problem:</h5>   
                                          <br />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <img alt='bebimage109' className="card-img-top" src={baseUrl+'assets/images/bebimg109.PNG'} />                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5>Q9.1. Suppose the family had 2 mobile phones with no charge in batteries. Now if the family had 2 chargers, select a way that may provide the shortest time needed to fully recharge the phones.</h5>
                                        {MCQAnswers('row', 25,{que25},
                                        'charging mobile1 for 1 hour and then charging mobile2 for 1 hour=total time 2 hours'
                                        ,'charging mobile1 for ½ hour and then charging mobile2 for ½ hour and charging mobile1 for 1/2hr and finally charging mobile2 for ½ hour=total time 2 hours',
                                        'charging mobile1 and mobile2 at the same time for 1 hour=total time 1 hour'
                                        ,'None of the above' )}
                                        <h5>Q9.2. Consider the question 9, the family has 3 mobile phones with no charge in batteries. Now if the family had 2 chargers, select a way that may provide the shortest time needed to fully recharge the phones:</h5>
                                              {MCQAnswers('row', 26,{que26},
                                              'charging mobile1 and mobile2 for 1 hour and then charging mobile3 for 1 hour'
                                              ,'charging mobile1 and mobile2 for ½ hour and then charging mobile2 and mobile3 for ½ hour and finally charging mobile1 and mobile3 for 1/2hr',
                                              'charging mobile1 and mobile2 for 1/2 hour and then charging mobile3 for 1 hour and then charging mobile1 and mobile2 for 1/2 hour'
                                              ,'None of the above' )} 
                                        <h5>Q9.3. What is the shortest time they need to fully recharge the three phones?</h5>
                                        {MCQAnswers('row', 27,{que27},'3 hours','2 hours','1 hour and a half','1 hour' )} 
                                          
                                    </GridItem> 
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                            </Accordion>
{/*............................................... Question10 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel10'} onChange={handleAccordionChange1('panel10')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>10. Beavers on the run </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>10. Beavers on the run </h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>   
                                        
                                        <img alt='beb110' className="card-img-top" src={baseUrl+'assets/images/beb110.PNG'} />
                                        <img alt='bebimg111' className="card-img-top" src={baseUrl+'assets/images/bebimg111.PNG'} />
                                        <h5> 
                                          With the information given above, Answer the questions below:</h5>
                                          <br />
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q10.1. Can you find the order of beaver in the hole from top to bottom when the beavers pass through first hole? </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage112' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg112.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                          
                                        {MCQAnswers('row', 28,{que28},'4321','1234','4567','None of the above' )}                                             
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                    <h5>Q10.2. Select the algorithm to find the order of beavers after passing through holes? </h5>
                                          
                                          {MCQAnswers('2x2', 29,{que29},
                                              <img alt='bebimage113' className="card-img-top" src={baseUrl+'assets/images/bebimg113.PNG'} />
                                              ,<img alt='bebimage114' className="card-img-top" src={baseUrl+'assets/images/bebimg114.PNG'} />
                                              ,<img alt='bebimage115' className="card-img-top" src={baseUrl+'assets/images/bebimg115.PNG'} />
                                              ,'None of the above'
                                              )} 
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>

                                        <h5>Q10.3. Select the order of beavers after they passed the third hole:</h5>
                                              {MCQAnswers('row', 30,{que30},
                                              '4756123',
                                              '6754321',
                                              '2165347',
                                              '5761432' )} 
                                          
                                    </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question11 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel11'} onChange={handleAccordionChange1('panel11')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>11. Levenshtein Distance </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>11. Levenshtein Distance</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                    <p>We define a basic operation as one of the following:</p>
                                      <p>• insert one character into a word,</p>
                                      <p>• remove one character from a word,</p>
                                      <p>• replace one character with another.</p>
                                      <p>We define the distance between two words as the minimum number of basic operations which
                                      allows us to change the first word into the second.</p>
                                      <p>For example, the distance between kitten and sitting is equal to 3. The basic operations
                                      necessary are:</p>
                                      <p>1. kitten → sitten (change k to s),</p>
                                      <p>2. sitten → sittin (change i to e),</p>
                                          3. sittin → sitting (insert g at the end).
                                        <h5> 
                                          With the information given above, Answer the question in the right hand side and below:</h5>
                                          <br />
                                          
                                 
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q11.1. Identify the common characters between length and french? </h5>
                                            {MCQAnswers('row', 31,{que31},
                                            'only ‘e’ and ‘h’','only ‘en’','‘en’ and ‘h’','None of the above' )} 
                                            
                          
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q11.2. Select basic operations to change from ‘length’ to ‘french’ in minimum number of operations? :</h5>
                                              {MCQAnswers('2x2', 32,{que32},
                                              <img alt='bebimage116' className="card-img-top" src={baseUrl+'assets/images/bebimg116.PNG'} />
                                              ,<img alt='bebimage117' className="card-img-top" src={baseUrl+'assets/images/bebimg117.PNG'} />
                                              ,<img alt='bebimage118' className="card-img-top" src={baseUrl+'assets/images/bebimg118.PNG'} />
                                              ,'None of the above'
                                              )} 
                                      <h5>Q11.3. What is the minimum distance between length and french?  </h5>
                                            {MCQAnswers('row', 33,{que33},
                                            '3','4','5','None of the above' )} 
                                    </GridItem> 
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question12 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>12. Candy maze </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>12. Candy maze</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <p>A robot is programmed to collect as many sweets as possible. It does this while walking
                                                  through cells.</p> 
                                                  <p>Each cell in the grid on the right has either 0, 1, 2 or 3 sweets.
                                                  The robot begins in the bottom-left and ends in the top-right. The robot can only move to the
                                                  right or upwards. </p>
                                                  <h5> With the information given above, Answer the question in the right hand side and below:</h5>

                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage119' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg119.PNG'} />
                                              </GridItem>
                                          </GridContainer>      
                                        
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <GridContainer>
                                          <GridItem xs={12} sm={12} md={6}>
                                              <h5>Q12.1. Given a path of robot from bottom end to top right in right hand side picture: </h5>
                                              <h5>Count the number of sweet collected. Select the options below:</h5> 
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={4}>
                                              <img alt='bebimage120' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg120.PNG'} />
                                          </GridItem>
                                      </GridContainer>
                                              
                                          {MCQAnswers('row', 34,{que34},'12','13','14','15' )}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q12.2. Select the path of robot to collect maximum possible sweets from the grid:</h5>
                                              {MCQAnswers('row', 35,{que35},
                                              <img alt='bebimage121' className="card-img-top" src={baseUrl+'assets/images/bebimg121.PNG'} />
                                              ,<img alt='bebimage120' className="card-img-top" src={baseUrl+'assets/images/bebimg120.PNG'} />
                                              ,<img alt='bebimage122' className="card-img-top" src={baseUrl+'assets/images/bebimg122.PNG'} />
                                              ,'None of the above'
                                              )}
                                          
                                          <h5>Q12.3. How many maximum sweets will the robot collect in the grid: </h5>
                                              {MCQAnswers('row', 36,{que36},'12','13','14','15' )}
                                    </GridItem> 
                                    {BebrasForm()}
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
                              <b>{error!=''?'error: '+error:''}</b>
                                  {isSubmit && <LinearProgress />} 
                                  <GridItem xs={12} sm={12} md={6}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          disabled={isSubmit}
                                          onClick={submitPatternForm}
                                        >
                                          Save
                                        </Button>
                                  </GridItem> 
                              </GridItem>
                            </GridContainer>
                          </GridItem>
                          
                      </GridContainer>
                    </GridItem>
                          :activeStep=='1' ?    ///Pattern Recognition
                          <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                            <h5 style={classes.fontCourier}><b> About the Test: </b> The test is used to assess the usability of the online platform. 
                                Below are some statements in which you may agree or disagree. Using the options given 
                                please indicate the extent of your agreement by marking the corresponding response for each statement.</h5>
                                <h5> Please make sure that you answer every item. There are no right or wrong answers.</h5>
                          <GridItem xs={12} sm={12} md={12}>
                            <Card>
                              <CardHeader color="success">
                              <h5 style={classes.cardTitleWhite}> {task[0]} </h5>
                              </CardHeader>
                                <b>{error!=''?'error: '+error:''}</b>
                              <CardBody>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={6}>
                                    <h4 align='center'>Statements related to online platform</h4>   
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Choose answers among </h5>
                                      <h5>Strongly Agree/Agree/Neutral/Disagree/Strongly disagree</h5> 
                                  </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="1.	I think that I would like to use this system frequently."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'1.	I think that I would like to use this system frequently.',value:'1.	I think that I would like to use this system frequently.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que37}
                                                onChange={handleQue37Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="2.	I found the system unnecessarily complex."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'2.	I found the system unnecessarily complex.',value:'2.	I found the system unnecessarily complex.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que38}
                                                onChange={handleQue38Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="3.	I thought the system was easy to use."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'3.	I thought the system was easy to use.',value:'3.	I thought the system was easy to use.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que39}
                                                onChange={handleQue39Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="4.	I think that I would need the support of a technical person to be able to use this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'4.	I think that I would need the support of a technical person to be able to use this system.',value:'4.	I think that I would need the support of a technical person to be able to use this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que40}
                                                onChange={handleQue40Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="5.	I found the various functions in this system were well integrated."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'5.	I found the various functions in this system were well integrated.',value:'5.	I found the various functions in this system were well integrated.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que41}
                                                onChange={handleQue41Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="6.	I thought there was too much inconsistency in this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'6.	I thought there was too much inconsistency in this system.',value:'6.	I thought there was too much inconsistency in this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que42}
                                                onChange={handleQue42Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="7.	I would imagine that most people would learn to use this system very quickly."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'7.	I would imagine that most people would learn to use this system very quickly.',value:'7.	I would imagine that most people would learn to use this system very quickly.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que43}
                                                onChange={handleQue43Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="8.	I found the system very cumbersome to use."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'8.	I found the system very cumbersome to use.',value:'8.	I found the system very cumbersome to use.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que44}
                                                onChange={handleQue44Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="9.	I felt very confident using the system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'9.	I felt very confident using the system.',value:'9.	I felt very confident using the system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que45}
                                                onChange={handleQue45Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="10.	I needed to learn a lot of things before I could get going with this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'10.	I needed to learn a lot of things before I could get going with this system.',value:'10.	I needed to learn a lot of things before I could get going with this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que46}
                                                onChange={handleQue46Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                        {SuSForm()}
   
                               
                                
                              </GridContainer>
                              </CardBody>
                            </Card>
                              {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                            <Card>
                              <CardHeader color="success">
                              <h5 style={classes.cardTitleWhite}> Feedback related to the Platform. Read each questions and answer accordingly</h5>
                              </CardHeader>
                                <b>{error!=''?'error: '+error:''}</b>
                              <CardBody>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={6}>
                                    <h4 align='center'>Feedback questions</h4>   
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Answer </h5>
                                  </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>   
                                            
                                            <h5>1.	Do you have any previous experience of using Algorithmic development app?
                                   
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que47}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue47Change} 
                                                />
                                                </h5>
                                            
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>   
                                          
                                            <h5>2. How much would you rate the CT-Onlinq app?(1=very bad, 2=bad, 3=normal, 4=good, 5=very good)
                                   
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que48}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue48Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                     
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>3. Did you find the CT-Onlinq app useful?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que49}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue49Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5> 4. What did you like about the CT-Onlinq app?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que50}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue50Change} 
                                                />
                                              </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>  5. What are the difficulties you faced with the functions of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que51}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue51Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                      
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5> 6.	What can we do to improve the User Interface of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que52}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue52Change} 
                                                />
                                              </h5>
                                    </GridItem>
                                                                        
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5> 7.	Any suggestions about the overall App that needs to be improved?
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que53}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue53Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                     
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5> 8.	What goals or benefits are you seeking through the use of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que54}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue54Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                            <h5> 9.	Would you like to motivate your friends to use CT-Onlinq? If yes/no, why?
                                              
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que55}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue55Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5> 10.	Do you have anything else you would like to share about CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que56}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue56Change} 
                                                />
                                              </h5>
                                    </GridItem>
                                        {SuSForm()}
   
                               
                                
                              </GridContainer>
                              </CardBody>
                            </Card>
                              {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>              
                    
                          :activeStep=='2' ? 

                          
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer>      
                                <h5 style={classes.fontCourier}><b> About the Test: </b> The test is used to assess the computational thinking self efficacy skills of the user. 
                                Below are some statements in which you may agree or disagree. Using the options given 
                                please indicate the extent of your agreement by marking the corresponding response for each statement.</h5>
                                <h5> Please make sure that you answer every item. There are no right or wrong answers.</h5>
                              <GridItem xs={12} sm={12} md={12}>

                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> {task[2]}</h4>

                                </CardHeader>
                                <p><i>{ansType}</i></p>
                                <b>{error!=''?'error: '+error:''}</b>
                                <CardBody>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h4>Statements related to your ability to perform tasks</h4>   
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Choose answers among </h5>
                                      <h5>Strongly Agree/Agree/Neutral/Disagree/Strongly disagree</h5> 
                                  </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="1. I distinguish repeating structures within data or images."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'1. I distinguish repeating structures within data or images.',value:'1. I distinguish repeating structures within data or images.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self1}
                                                onChange={handleSelf1Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="2. I evaluate the steps necessary to solve the problem from different angles. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'2. I evaluate the steps necessary to solve the problem from different angles. ',value:'2. I evaluate the steps necessary to solve the problem from different angles. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self2}
                                                onChange={handleSelf2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="3. I run multiple tasks at the same time to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'3. I run multiple tasks at the same time to solve the problem. ',value:'3. I run multiple tasks at the same time to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self3}
                                                onChange={handleSelf3Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. ',value:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self4}
                                                onChange={handleSelf4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="5. I examine the data I have collected to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'5. I examine the data I have collected to solve the problem. ',value:'5. I examine the data I have collected to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self5}
                                                onChange={handleSelf5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="6. I relate problems to real life. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'6. I relate problems to real life. ',value:'6. I relate problems to real life. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self6}
                                                onChange={handleSelf6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="7. I separate the data by type (text, number, series, etc.). "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'7. I separate the data by type (text, number, series, etc.). ',value:'7. I separate the data by type (text, number, series, etc.). '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self7}
                                                onChange={handleSelf7Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="8. I understand whether the problem is composed of sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'8. I understand whether the problem is composed of sub-problems. ',value:'8. I understand whether the problem is composed of sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self8}
                                                onChange={handleSelf8Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="9. I decide whether the data to be used to solve the problem is sufficient or not. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'9. I decide whether the data to be used to solve the problem is sufficient or not. ',value:'9. I decide whether the data to be used to solve the problem is sufficient or not. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self9}
                                                onChange={handleSelf9Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="10. I comment on the data I used to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'10. I comment on the data I used to solve the problem. ',value:'10. I comment on the data I used to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self10}
                                                onChange={handleSelf10Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="11. I connect the problem I have encountered with the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'11. I connect the problem I have encountered with the problems I have encountered before. ',value:'11. I connect the problem I have encountered with the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self11}
                                                onChange={handleSelf11Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="12. If the problem has sub-problems, I manage the solution processes of these sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. ',value:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self12}
                                                onChange={handleSelf12Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="13. I find the fastest solution that works correctly through different process steps. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'13. I find the fastest solution that works correctly through different process steps. ',value:'13. I find the fastest solution that works correctly through different process steps. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self13}
                                                onChange={handleSelf13Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="14. I can understand how a problem I have encountered differs from the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. ',value:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self14}
                                                onChange={handleSelf14Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="15. I organize the data I collect in a way that is more understandable for the solution of the problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.',value:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self15}
                                                onChange={handleSelf15Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="16. I decide whether the problem solution I chose is fit for purpose. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'16. I decide whether the problem solution I chose is fit for purpose. ',value:'16. I decide whether the problem solution I chose is fit for purpose. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self16}
                                                onChange={handleSelf16Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="17. If the problem has sub-problems, I divide it into smaller sub-problems."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'17. If the problem has sub-problems, I divide it into smaller sub-problems.',value:'17. If the problem has sub-problems, I divide it into smaller sub-problems.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self17}
                                                onChange={handleSelf17Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="18. I develop different solution proposals for the solution of a problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'18. I develop different solution proposals for the solution of a problem.',value:'18. I develop different solution proposals for the solution of a problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self18}
                                                onChange={handleSelf18Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {EfficacyForm()}
                                    </GridItem>
                                    
                                    <b>{error!=''?'error: '+error:''}</b>
                                </GridContainer>
                                </CardBody>
                                {isSubmit && <LinearProgress />}
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmit}
                                    onClick={submitAbstractionForm}
                                  >
                                    Save
                                  </Button>
                                </GridItem> 
                              </GridItem>
                                
                                
                              </GridContainer>
                            </GridItem>                           
                           
                          :null}

                      </GridContainer>
                      {loading!==true?
                      <GridContainer>
                            <GridItem xs={12} sm={12} md={9}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                            {isSubmit && <LinearProgress />}
                              <div>
                                {activeStep === steps.length-1 ?(
                                <div>
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                    </Button>
                                  
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      disabled={isSubmit}
                                      onClick={handleNext}
                                    >
                                      Submit Final 
                                    </Button>
                                </div>):
                                (
                                  <div>
                                    <div>
                                      <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      <Button variant="contained" 
                                        disabled={isSubmit}
                                        color="primary" 
                                        onClick={handleNext}>
                                        Submit and Go to Next Step
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                  </GridContainer>
                </GridItem>
            </GridContainer>:null}
                                                                      

          </Form>
          </LocalizationProvider>
          )}
          
          </Formik>
         

    </div>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
    );
}

